class itemList {
  constructor(items) {
    this.itemList = items;
    this.item = [];
    this._itemArea();
    this._itemDatail();
  }
  _itemArea() {
    this.itemList.forEach((e) => {
      this.itemArea = Object.keys(e);

      this.itemArea.forEach((element) => {
        this.list = document.querySelector("." + element);
        if (this.list) {
          this.itemDetail = e[`${element}`];
          this.itemDetail.forEach((info, i) => {
            this.g = Object.keys(info);
            let u = [];
            this.g.forEach((key) => {
              u.push(info[`${key}`]);
              return u;
            });
            this.item += this._itemDatail(...u);
          });
          this.list.innerHTML = this.item;
        }
        this.item = [];
      });
    });
  }
  _itemDatail(a, b) {
    return `<p>${a}/${b}</p>`;
  }
}

//セールアイテム　画像あり
class saleImage extends itemList {
  constructor(items) {
    super(items);
  }
  _itemDatail(a, b, c, d, e, f, g) {
    if (g) {
      return `
            <div class="itemBox tO">
                <a href="/fs/osmosis/${a}">
                    <span class="itemImg"><img src="https://osmosis.itembox.design/item/img/${e}" alt="${b}"></span>
                    <span class="itemInfo">
                        <span class="itemName">${b}</span>
                        <span class="itemPrice">&yen; ${d}</span>
                        <span class="itemSale">&yen; ${c}</span>
                    </span>
                    <span class="itemColor">${g}</span>
                    <span class="itemRate">${f}%</span>
                </a>
            </div>
            
            `;
    } else {
      return `
            <div class="itemBox tO">
                <a href="/fs/osmosis/${a}">
                    <span class="itemImg"><img src="https://osmosis.itembox.design/item/img/${e}" alt="${b}"></span>
                    <span class="itemInfo">
                        <span class="itemName">${b}</span>
                        <span class="itemPrice">&yen; ${d}</span>
                        <span class="itemSale">&yen; ${c}</span>
                    </span>
                    <span class="itemRate">${f}%</span>
                </a>
            </div>
            
            `;
    }
  }
}

//セールアイテム　画像なし
class saleNoImage extends itemList {
  constructor(items) {
    super(items);
  }
  _itemDatail(a, b, c, d, e, f, g) {
    if (f) {
      return `
            <div class="itemBox">
                <a href="/fs/osmosis/${a}">
                    <span class="itemInfo">
                        <span class="itemName">${b}</span>
                        <span class="itemPrice">&yen; ${d}</span>
                        <span class="itemSale">&yen; ${c}</span>
                    </span>
                    <span class="itemColor">&yen; ${f}</span>
                    <span class="itemRate">&yen; ${g}%</span>
                </a>
            </div>
            `;
    } else {
      return `
            <div class="itemBox">
                <a href="/fs/osmosis/${a}">
                    <span class="itemInfo">
                        <span class="itemName">${b}</span>
                        <span class="itemPrice">&yen; ${d}</span>
                        <span class="itemSale">&yen; ${c}</span>
                    </span>
                    <span class="itemRate">&yen; ${g}%</span>
                </a>
            </div>
            `;
    }
  }
}

//通常アイテム　画像あり
class normalImage extends itemList {
  constructor(items) {
    super(items);
  }
  _itemDatail(a, b, c, d, e, f) {
    if (f) {
      return `
            <div class="itemBox">
                <a href="/fs/osmosis/${a}">
                    <span class="itemImg"><img src="https://osmosis.itembox.design/item/img/${e}" alt="${b}"></span>
                    <span class="itemInfo">
                        <span class="itemName">${b}</span>
                        <span class="itemSale">&yen; ${c}</span>
                    </span>
                    <span class="itemColor">&yen; ${f}</span>
                </a>
            </div>
            `;
    } else {
      return `
            <div class="itemBox">
                <a href="/fs/osmosis/${a}">
                    <span class="itemImg"><img src="https://osmosis.itembox.design/item/img/${e}" alt="${b}"></span>
                    <span class="itemInfo">
                        <span class="itemName">${b}</span>
                        <span class="itemSale">&yen; ${c}</span>
                    </span>
                </a>
            </div>
            `;
    }
  }
}

//通常アイテム　画像なし
class normalNoImage extends itemList {
  constructor(items) {
    super(items);
  }
  _itemDatail(a, b, c, d, e, f) {
    if (f) {
      return `
            <div class="itemBox">
                <a href="/fs/osmosis/${a}">
                    <span class="itemInfo">
                        <span class="itemName">${b}</span>
                        <span class="itemSale">&yen; ${c}</span>
                    </span>
                    <span class="itemColor">&yen; ${f}</span>
                </a>
            </div>
            `;
    } else {
      return `
            <div class="itemBox">
                <a href="/fs/osmosis/${a}">
                    <span class="itemInfo">
                        <span class="itemName">${b}</span>
                        <span class="itemSale">&yen; ${c}</span>
                    </span>
                </a>
            </div>
            `;
    }
  }
}
//通常アイテム　画像なし divなし
class normalNoImageNoDiv extends itemList {
  constructor(items) {
    super(items);
  }
  _itemDatail(a, b, c, d, e, f) {
    if (f) {
      return `
                <a href="/fs/osmosis/${a}">
                    <span class="itemInfo">
                        <span class="itemName">${b}</span>
                        <span class="itemSale">&yen; ${c}</span>
                    </span>
                    <span class="itemColor">&yen; ${f}</span>
                </a>
            `;
    } else {
      return `
                <a href="/fs/osmosis/${a}">
                    <span class="itemInfo">
                        <span class="itemName">${b}</span>
                        <span class="itemSale">&yen; ${c}</span>
                    </span>
                </a>
            `;
    }
  }
}

//通常アイテム　画像なし divなし
class topContents extends itemList {
  constructor(items) {
    super(items);
  }
  _itemDatail(a, b, c, d, e) {
    if (e) {
      return `
            <div class="contentsBox">
                <a href="${a}"  target="_${e}">
                    <span class="contentsImg"><img src="https://osmosis.itembox.design/item/img/top/${d}.jpg" alt="${b}"></span>
                    <span class="contentsInfo">
                        <span class="contentsDays">${c}</span>
                        <span class="contentsName">${b}</span>
                    </span>
                </a>
            </div>
            `;
    } else {
      return `
            <div class="contentsBox">
                <a href="${a}">
                    <span class="contentsImg"><img src="https://osmosis.itembox.design/item/img/top/${d}.jpg" alt="${b}"></span>
                    <span class="contentsInfo">
                        <span class="contentsDays">${c}</span>
                        <span class="contentsName">${b}</span>
                    </span>
                </a>
            </div>
            `;
    }
  }
}

//swiperItem
class swiperItem extends itemList {
  constructor(items) {
    super(items);
  }
  _itemDatail(a, b, c, d, e) {
    if (e) {
      return `
            <div class="swiper-slide">
                <a href="${a}" target="_${e}">
                    <span class="swiperImg"><img src="https://osmosis.itembox.design/item/img/top/${d}.jpg" alt="${b}"></span>
                    <span class="swiperInfo">
                        <span class="contentsDays">${c}</span>
                    </span>
                </a>
            </div>
            `;
    } else {
      return `
            <div class="swiper-slide">
                <a href="${a}" target="_${e}">
                    <span class="swiperImg"><img src="https://osmosis.itembox.design/item/img/top/${d}.jpg" alt="${b}"></span>
                    <span class="swiperInfo">
                        <span class="contentsDays">${c}</span>
                    </span>
                </a>
            </div>
            `;
    }
  }
}

//topSlider
class topSlider extends itemList {
  constructor(items) {
    super(items);
  }
  _itemDatail(a, b, c, d) {
    if (d) {
      return `
            <div>
                <a href="${a}" target="_${d}">
                    <img class="sp" src="https://osmosis.itembox.design/item/img/top/${c}_sp.jpg" alt="${b}">
                    <img class="pc" src="https://osmosis.itembox.design/item/img/top/${c}_pc.jpg" alt="${b}">
                </a>
            </div>
            `;
    } else {
      return `
            <div>
                <a href="${a}">
                    <img class="sp" src="https://osmosis.itembox.design/item/img/top/${c}_sp.jpg" alt="${b}">
                    <img class="pc" src="https://osmosis.itembox.design/item/img/top/${c}_pc.jpg" alt="${b}">
                </a>
            </div>
            `;
    }
  }
}

//snapSlider
class snapSlider extends itemList {
  constructor(items) {
    super(items);
  }
  _itemDatail(a, b) {
    return `
            <div>
                <a href="/shopcoordinate/index.php/${a}">
                    <img src="https://store.osmosis.co.jp/shopcoordinate/wp-content/uploads/${b}.jpg">
                </a>
            </div>
            `;
  }
}

//topStyle
class topStyle extends itemList {
  constructor(items) {
    super(items);
  }
  _itemDatail(a, b, c) {
    return `
            <p class="fade_u animated ${c}">
                <a href="/shopcoordinate/index.php/recommend/recommend-styling-${a}/">
                    <img src="https://osmosis.itembox.design/item/img/recommend/${b}.jpg">
                </a>
            </p>
            `;
  }
}

//NOID TOP BANNER
class noidTopBanner extends itemList {
  constructor(items) {
    super(items);
  }
  _itemDatail(a, b, c, d, e, f) {
    if (f) {
      return `
            <div class="${e}banner">
                <a href="https://store.noid.jp/${a}">
                <img class="spImg" src="/template/default/img/top/${d}_sp.webp" alt="${b}">
                <img class="pcImg" src="/template/default/img/top/${d}_pc.webp" alt="${b}">
                </a>
            </div>
        `;
    } else {
      return `
                <div class="${e}banner">
                    <a href="https://store.noid.jp/${a}">
                    <img src="/template/default/img/top/${d}.webp" alt="${b}">
                    </a>
                </div>
            `;
    }
  }
}

//NOID TOP CONTENTS
class noidTopContents extends itemList {
  constructor(items) {
    super(items);
  }
  _itemDatail(a, b, c, d, e) {
    if (e) {
      return `
                <div class="pickup_item">
                    <a href="https://store.noid.jp/${a}">
                        <div class="item_photo"><img class="inviewImg" src="/template/default/img/main/white10-10.jpg" data-src="/template/default/img/${e}/${d}.webp" alt="${b}"></div>
                        <dl>
                            <dt class="item_name">${c}</dt>
                            <dd id="result_list__price02_inc_tax--20" class="item_price">
                                ${b}
                            </dd>
                        </dl>
                    </a>
                </div>
        `;
    } else {
      return `
                <div class="pickup_item">
                    <a href="https://store.noid.jp/${a}">
                        <div class="item_photo"><img class="inviewImg" src="/template/default/img/main/white10-10.jpg" data-src="/template/default/img/top/${d}.webp" alt="${b}"></div>
                        <dl>
                            <dt class="item_name">${c}</dt>
                            <dd id="result_list__price02_inc_tax--20" class="item_price">
                                ${b}
                            </dd>
                        </dl>
                    </a>
                </div>
        `;
    }
  }
}

//NOID COORDINATE 1段目
class noidLookBookTop extends itemList {
  constructor(items) {
    super(items);
  }
  _itemDatail(a, b, c) {
    if (c) {
      return `
            <div>
                <a href="/LOOKBOOK/${a}/">
                <img class="inviewImg" data-src="/template/default/img/top_model/${c}.jpg">
                </a>
            </div>
        `;
    } else {
      return `
            <div>
                <a href="/LOOKBOOK/${a}/">
                <img class="inviewImg" data-src="/lookbook/img/${b}.jpg" >
                </a>
            </div>
        `;
    }
  }
}

//NOID COORDINATE 2段目
class noidLookBookTop2 extends itemList {
  constructor(items) {
    super(items);
  }
  _itemDatail(a, b, c) {
    if (c) {
      return `
            <div>
                <a href="/LOOKBOOK/${a}/">
                <img class="inviewImg" data-src="/template/default/img/top_model/${c}.jpg">
                </a>
            </div>
        `;
    } else {
      return `
            <div>
                <a href="/LOOKBOOK/${a}/">
                <img class="inviewImg" data-src="/lookbook/img/${b}.jpg" >
                </a>
            </div>
        `;
    }
  }
}
